var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.293 26.1054L29.2305 40.1679C28.9373 40.4611 28.5396 40.6258 28.125 40.6258C27.7104 40.6258 27.3127 40.4611 27.0195 40.1679C26.7263 39.8747 26.5616 39.477 26.5616 39.0624C26.5616 38.6478 26.7263 38.2501 27.0195 37.9569L38.416 26.5624H7.8125C7.3981 26.5624 7.00067 26.3978 6.70765 26.1047C6.41462 25.8117 6.25 25.4143 6.25 24.9999C6.25 24.5855 6.41462 24.1881 6.70765 23.895C7.00067 23.602 7.3981 23.4374 7.8125 23.4374H38.416L27.0195 12.0429C26.7263 11.7497 26.5616 11.352 26.5616 10.9374C26.5616 10.5228 26.7263 10.1251 27.0195 9.83192C27.3127 9.53873 27.7104 9.37402 28.125 9.37402C28.5396 9.37402 28.9373 9.53873 29.2305 9.83192L43.293 23.8944C43.4382 24.0395 43.5535 24.2119 43.6321 24.4015C43.7108 24.5912 43.7512 24.7946 43.7512 24.9999C43.7512 25.2052 43.7108 25.4086 43.6321 25.5982C43.5535 25.7879 43.4382 25.9602 43.293 26.1054Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhArrowRight);
export default __webpack_public_path__ + "static/media/ph_arrow-right.82f2fe18365484b0a90e07be5e0bf3a8.svg";
export { ForwardRef as ReactComponent };